const defaultHit = val => Boolean(val);
export function LazyGetter(getterFn, opts = {
  hit: defaultHit,
  enumerable: false
}) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  return function (_target, key) {
    return {
      get() {
        const val = getterFn.apply(this);
        if (opts.hit(val)) {
          Object.defineProperty(this, key, {
            value: val,
            enumerable: opts.enumerable,
            configurable: true
          });
        }
        return val;
      },
      enumerable: opts.enumerable,
      configurable: true
    };
  };
}
//# sourceMappingURL=LazyGetter.js.map
